// extracted by mini-css-extract-plugin
export default {"caption":"atDBFv","whiteTheme":"btDBFv","blueTheme":"ctDBFv","xsSize":"dtDBFv","sSize":"etDBFv","mSize":"ftDBFv","lSize":"gtDBFv","xlSize":"htDBFv","xxlSize":"itDBFv"};